<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพโหลดสลิปจ่ายเงินเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบรูปภาพเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div>
        <v-card elevation="6">
          <div class="pa-3">
            <v-tabs v-model="activeTab" grow color="#86bc3a" slider-color="#86bc3a" active-class="active-tab">
              <v-tab style="font-size: 18px">ช่องทางการโอนเงิน ขายปลีก</v-tab>
              <v-tab style="font-size: 18px">ช่องทางการโอนเงิน ขายส่ง</v-tab>
            </v-tabs>
          </div>

          <v-divider></v-divider>

          <v-tabs-items v-model="activeTab">
            <!-- Tab 1: ขายปลีก -->
            <v-tab-item>
              <v-card elevation="0">
                <div class="pa-2">
                  <div class="text-right ma-2 mb-4">
                    <v-btn x-large class="text-center grad-success-bg white--text mobile_btn"
                      @click="slip_modal = true">เพิ่มการชำระเงิน</v-btn>
                  </div>
                  <div v-if="loading_list === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                  </div>
                  <div v-else v-for="(data, index) in data_list_retail" :key="index">
                    <v-card elevation="1" class="pa-2 ma-2">
                      <div class="grid_item">
                        <div class="ml-2 grid_picture">
                          <div class="grid_mx">
                            <v-img class="rounded" height="120" width="120" max-width="120"
                              v-if="data.bank_image === ''" :lazy-src="img_holder" :src="img_holder"></v-img>
                            <v-img class="rounded" height="120" width="120" max-width="120"
                              v-if="data.bank_image !== ''" :lazy-src="img_holder" :src="data.bank_image"></v-img>
                          </div>
                          <div class="ml-3 pt-5">
                            <div>ชื่อธนาคาร : {{ data.bank_name }}</div>
                            <div>เลขที่บัญชี : {{ data.bank_number }}</div>
                            <div>ชื่อบัญชี : {{ data.bank_account }}</div>
                            <div>ประเภทบัญชี : {{ data.bank_type == 1 ? 'บุคคลธรรมดา' : 'นิติบุคคล' }}</div>
                          </div>
                        </div>
                        <div>
                          <div class="text-right">
                            <div class="item_grid">
                              <div>แสดงหน้าเว็บไซต์</div>
                              <v-switch class="mt-0 ml-3" color="#86bc3a" @change="changeStatus(data.id, data.status)"
                                v-model="data.status"></v-switch>
                            </div>
                            <div>
                              <v-btn small height="42" class="grad-warning-bg white--text mb-1 card_btn"
                                style="font-size: 18px" @click="image_get(data.id)" title="แก้ไขรูปภาพ">
                                <v-icon>mdi-delete-edit-outline</v-icon>แก้ไข
                              </v-btn>
                            </div>
                            <div>
                              <v-btn small height="42" class="grad-danger-bg white--text mb-1 card_btn"
                                style="font-size: 18px" @click="image_remove(data.id, data.loop_id)" title="ลบรูปภาพ">
                                <v-icon>mdi-delete-empty-outline</v-icon>ลบ
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </v-card>
            </v-tab-item>

            <!-- Tab 2: ขายส่ง -->
            <v-tab-item>
              <v-card elevation="0">
                <div class="pa-2">
                  <div class="text-right ma-2 mb-4">
                    <v-btn x-large class="text-center grad-success-bg white--text mobile_btn"
                      @click="slip_modal = true">เพิ่มการชำระเงิน</v-btn>
                  </div>
                  <div v-if="loading_list === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                  </div>
                  <div v-else v-for="(data, index) in data_list" :key="index">
                    <v-card elevation="1" class="pa-2 ma-2">
                      <div class="grid_item">
                        <div class="ml-2 grid_picture">
                          <div class="grid_mx">
                            <v-img class="rounded" height="120" width="120" max-width="120"
                              v-if="data.bank_image === ''" :lazy-src="img_holder" :src="img_holder"></v-img>
                            <v-img class="rounded" height="120" width="120" max-width="120"
                              v-if="data.bank_image !== ''" :lazy-src="img_holder" :src="data.bank_image"></v-img>
                          </div>
                          <div class="ml-3 pt-5">
                            <div>ชื่อธนาคาร : {{ data.bank_name }}</div>
                            <div>เลขที่บัญชี : {{ data.bank_number }}</div>
                            <div>ชื่อบัญชี : {{ data.bank_account }}</div>
                            <div>ประเภทบัญชี : {{ data.bank_type == 1 ? 'บุคคลธรรมดา' : 'นิติบุคคล' }}</div>
                          </div>
                        </div>
                        <div>
                          <div class="text-right">
                            <div class="item_grid">
                              <div>แสดงหน้าเว็บไซต์</div>
                              <v-switch class="mt-0 ml-3" color="#86bc3a" @change="changeStatus(data.id, data.status)"
                                v-model="data.status"></v-switch>
                            </div>
                            <div>
                              <v-btn small height="42" class="grad-warning-bg white--text mb-1 card_btn"
                                style="font-size: 18px" @click="image_get(data.id)" title="แก้ไขรูปภาพ">
                                <v-icon>mdi-delete-edit-outline</v-icon>แก้ไข
                              </v-btn>
                            </div>
                            <div>
                              <v-btn small height="42" class="grad-danger-bg white--text mb-1 card_btn"
                                style="font-size: 18px" @click="image_remove(data.id, data.loop_id)" title="ลบรูปภาพ">
                                <v-icon>mdi-delete-empty-outline</v-icon>ลบ
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
      <v-dialog v-model="slip_modal" max-width="700">
        <v-card>
          <v-form ref="image" @submit.prevent="upload_image">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มช่องทางการชำระเงิน
              </v-card-title>
              <v-btn icon class="ma-4" @click="slip_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="img_holder"
                    :src="img_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL"
                    class="preview mx-auto"></v-img>
                </div>
                <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปภาพ" v-model="slip_image"
                  @change="onFileChange"></v-file-input>
                <div class="grid_full">
                  <div>
                    <v-radio-group v-model="send_data.bank_type">
                      <div class="d-flex">
                        <div class="d-flex mr-1">
                          <div>
                            <v-radio color="#86bc3a" :value="0"></v-radio>
                          </div>
                          <div>นิติบุคคล</div>
                        </div>
                        <div class="d-flex ml-1">
                          <div>
                            <v-radio color="#86bc3a" :value="1"></v-radio>
                          </div>
                          <div>บุคคลธรรมดา</div>
                        </div>
                      </div>
                    </v-radio-group>
                  </div>
                  <div>
                    <div>ชื่อธนาคาร</div>
                    <div class="mt-3">
                      <v-text-field color="#86bc3a" label="ชื่อธนาคาร" :rules="[v => !!v || 'กรุณากรอกชื่อธนาคาร']"
                        required hide-details="auto" v-model="send_data.bank_name" outlined></v-text-field>
                    </div>
                  </div>
                  <div>
                    <div>เลขบัญชี</div>
                    <div class="mt-3">
                      <v-text-field color="#86bc3a" type="tel" maxlength="13" label="เลขบัญชี"
                        :rules="[v => !!v || 'กรุณากรอกเลขบัญชี']" required @keypress="isOnlyNumber($event)"
                        v-model="send_data.bank_number" hide-details="auto" outlined></v-text-field>
                    </div>
                  </div>
                  <div>
                    <div>ชื่อบัญชี</div>
                    <div class="mt-3">
                      <v-text-field color="#86bc3a" label="ชื่อบัญชี" hide-details="auto"
                        :rules="[v => !!v || 'กรุณากรอกชื่อบัญชี']" required v-model="send_data.bank_account"
                        outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="mt-6 text-center">
                  <v-btn x-large v-if="imagePreviewURL == null" class="white--text grad-grey-bg btn_width"
                    disabled>บันทึก</v-btn>
                  <v-btn x-large v-if="imagePreviewURL !== null" type="submit"
                    class="white--text grad-success-bg btn_width">บันทึก</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="edit_modal" max-width="700">
        <div v-if="loading_edit === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else>
          <v-card>
            <v-form ref="image_edit" @submit.prevent="upload_edit">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  แก้ไขช่องทางการชำระเงิน
                </v-card-title>
                <v-btn icon class="ma-4" @click="edit_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-4">
                    <v-img height="300" max-width="300" v-if="data_list_edit.bank_image === ''" :lazy-src="img_holder"
                      :src="default_img" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-if="data_list_edit.bank_image !== ''"
                      :src="data_list_edit.bank_image" class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปภาพ" v-model="slip_image_edit"
                    @change="onFileChangeEdit"></v-file-input>
                  <div class="grid_full">
                    <div>
                      <v-radio-group v-model="data_list_edit.bank_type">
                        <div class="d-flex">
                          <div class="d-flex mr-1">
                            <div>
                              <v-radio color="#86bc3a" :value="0"></v-radio>
                            </div>
                            <div>นิติบุคคล</div>
                          </div>
                          <div class="d-flex ml-1">
                            <div>
                              <v-radio color="#86bc3a" :value="1"></v-radio>
                            </div>
                            <div>บุคคลธรรมดา</div>
                          </div>
                        </div>
                      </v-radio-group>
                    </div>
                    <div>
                      <div>ชื่อธนาคาร</div>
                      <div class="mt-3">
                        <v-text-field color="#86bc3a" label="ชื่อธนาคาร" :rules="[v => !!v || 'กรุณากรอกชื่อธนาคาร']"
                          required hide-details="auto" v-model="data_list_edit.bank_name" outlined></v-text-field>
                      </div>
                    </div>
                    <div>
                      <div>เลขบัญชี</div>
                      <div class="mt-3">
                        <v-text-field color="#86bc3a" type="tel" maxlength="13" label="เลขบัญชี"
                          :rules="[v => !!v || 'กรุณากรอกเลขบัญชี']" required @keypress="isOnlyNumber($event)"
                          v-model="data_list_edit.bank_number" hide-details="auto" outlined></v-text-field>
                      </div>
                    </div>
                    <div>
                      <div>ชื่อบัญชี</div>
                      <div class="mt-3">
                        <v-text-field color="#86bc3a" label="ชื่อบัญชี" hide-details="auto"
                          :rules="[v => !!v || 'กรุณากรอกชื่อบัญชี']" required v-model="data_list_edit.bank_account"
                          outlined></v-text-field>
                      </div>
                    </div>
                  </div>
                  <div class="mt-6 text-center">
                    <v-btn x-large v-if="data_list_edit.bank_image === ''" class="white--text grad-grey-bg btn_width"
                      disabled>บันทึก</v-btn>
                    <v-btn x-large v-if="data_list_edit.bank_image !== ''" type="submit"
                      class="white--text grad-success-bg btn_width">บันทึก</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </div>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/picture.png";
import Swal from "sweetalert2";
import { onlyForNumber } from "@/js/handler";
import { HTTP } from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Transfer_setting",
  data() {
    return {
      activeTab: 0,
      data_list_retail: [],
      loading_page: false,
      loading_edit: false,
      loading_list: false,
      image_modal: false,
      overlay: false,
      slip_modal: false,
      edit_modal: false,
      alert_success: false,
      alert_status: false,
      alert_delete: false,
      imagePreviewURL: null,
      slip_image: null,
      slip_image_edit: null,
      img_holder: img_holder,
      default_img: null,
      send_data: {
        bank_type: 0,
        bank_name: '',
        bank_number: '',
        bank_account: '',
      },
      image: null,
      data_list: [],
      data_list_edit: [],
      loop_id: 0,
    }
  },
  methods: {
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.slip_image = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.slip_image = null
          }
        }
      } else {
        this.imagePreviewURL = null
        this.slip_image = null
      }
    },
    onFileChangeEdit(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.data_list_edit.bank_image = null
            this.slip_image_edit = null
          })
        } else {
          if (file) {
            this.data_list_edit.bank_image = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.data_list_edit.bank_image = ''
            this.slip_image_edit = null
          }
        }
      } else {
        this.data_list_edit.bank_image = ''
        this.slip_image_edit = null
      }
    },
    get_transfer_list() {
      this.loading_list = true;

      // ดึงข้อมูล Wholesale
      HTTP.post('/manage-website/banks/all', {
        status_channels: 'Wholesale'
      }).then((res) => {
        if (res.data.success === true) {
          this.data_list = res.data.object
          for (let i = 0; i < this.data_list.length; i++) {
            this.data_list[i].status = parseInt(this.data_list[i].status) === 1 ? true : false
            this.data_list[i].loop_id = i
          }
        }
      });

      // ดึงข้อมูล Retail
      HTTP.post('/manage-website/banks/all', {
        status_channels: 'Retail'
      }).then((res) => {
        if (res.data.success === true) {
          this.data_list_retail = res.data.object
          for (let i = 0; i < this.data_list_retail.length; i++) {
            this.data_list_retail[i].status = parseInt(this.data_list_retail[i].status) === 1 ? true : false
            this.data_list_retail[i].loop_id = i
          }
          this.loading_list = false;
          this.loading_page = false;
        }
      });
    },
    upload_image() {
      if (this.$refs.image.validate()) {
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.slip_image.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.slip_image = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('image', this.slip_image, this.slip_image.name)
          formData.append('bank_type', this.send_data.bank_type)
          formData.append('bank_name', this.send_data.bank_name)
          formData.append('bank_number', this.send_data.bank_number)
          formData.append('bank_account', this.send_data.bank_account)
          formData.append('status_channels', this.activeTab === 0 ? 'Retail' : 'Wholesale')
          this.overlay = true
          this.slip_modal = false
          HTTP.post('/manage-website/banks/create', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.send_data.bank_name = ''
                this.send_data.bank_number = ''
                this.send_data.bank_account = ''
                this.imagePreviewURL = null
                this.slip_image = null
                this.get_transfer_list()
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 3000)
              }
            })
        }
      }
    },
    changeStatus(id, status) {
      HTTP.post('/manage-website/banks/status', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
    image_get(id) {
      this.edit_modal = true
      this.loading_edit = true
      HTTP.post('/manage-website/banks/getbank', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_edit = false
          this.data_list_edit = res.data.object
          this.default_img = res.data.object.bank_image
        }
      })
    },
    upload_edit() {
      if (this.$refs.image_edit.validate()) {
        if (this.slip_image_edit !== null && this.slip_image_edit !== '') {
          let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
          let file = this.slip_image_edit.name;
          let ext = file.split('.').pop().toLowerCase();
          if (parseInt(extall.indexOf(ext)) < 0) {
            Swal.fire({
              text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.slip_image_edit = null
            })
          }
          else {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            formData.append('image', this.slip_image_edit, this.slip_image_edit.name)
            formData.append('id', this.data_list_edit.id)
            formData.append('bank_type', this.data_list_edit.bank_type)
            formData.append('bank_name', this.data_list_edit.bank_name)
            formData.append('bank_number', this.data_list_edit.bank_number)
            formData.append('bank_account', this.data_list_edit.bank_account)
            this.overlay = true
            this.edit_modal = false
            HTTP.post('/manage-website/banks/update', formData, config)
              .then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  this.data_list_edit.bank_image = ''
                  this.get_transfer_list()
                  this.alert_success = true
                  setTimeout(() => this.alert_success = false, 3000)
                }
              })
          }
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          // formData.append('image', this.slip_image_edit, this.slip_image_edit.name)
          formData.append('id', this.data_list_edit.id)
          formData.append('bank_type', this.data_list_edit.bank_type)
          formData.append('bank_name', this.data_list_edit.bank_name)
          formData.append('bank_number', this.data_list_edit.bank_number)
          formData.append('bank_account', this.data_list_edit.bank_account)
          this.overlay = true
          this.edit_modal = false
          HTTP.post('/manage-website/banks/update', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.data_list_edit.bank_image = ''
                this.get_transfer_list()
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 3000)
              }
            })
        }
      }
    },
    image_remove(id, loop_id) {
      Swal.fire({
        title: 'คุณต้องการลบรูปภาพหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/banks/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 3000)
              this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_transfer_list()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.mobile_btn {
  width: 25%;
}

.btn_width {
  width: 100%;
}

.card_btn {
  width: 40%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}

.item_grid {
  display: flex;
  justify-content: right;
}

.grid_item {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}

.grid_picture {
  display: flex;
}

.grid_mx {
  margin: 0;
}

.grid_item {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}

@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 30%;
  }

  .grid_picture {
    display: grid;
    grid-template-columns: 25% 80%;
  }

  .card_btn {
    width: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }

  .grid_mx {
    margin: auto;
  }

  .grid_picture {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_item {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .item_grid {
    display: flex;
    justify-content: left;
  }
}
</style>
